module.exports = __webpack_public_path__ + "8b0413810fbf4b31bdf74e5c6505d62c.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/tepasa.png
 ** module id = 530
 ** module chunks = 0
 **/